<template>
  <b-card>
    <b-card-header
      ><h3>{{ msg }}</h3></b-card-header>
    <b-card-body>
      <tabbed-display v-bind:tabs="tabs" width="100%"></tabbed-display>
    </b-card-body>
  </b-card>
</template>
<script>
import TabbedDisplay from "@/components/TabbedDisplay/TabbedDisplay";
import { DisplayTab } from "@/components/TabbedDisplay/DisplayTab.js";
import Numerology from "@/components/Numerology";
import CortexView from "@/components/CortexView";
import ShadowRunView from "@/components/ShadowRunView";
import CountdownView from "@/components/CountdownView";
export default {
  name: "MiscView",
  data() {
    return {
      msg: "Other Stuff",
      tabs: [],
    };
  },
  components: { TabbedDisplay },
  mounted() {
    this.tabs.push(
      new DisplayTab(
        "home",
        "Home",
        1,
        "<p>This is a collection of oddities and knick-knacks.</p>",
        []
      )
    );
    this.tabs.push(
      new DisplayTab("numerology", "Numerology", 2, "", [Numerology])
    );
    this.tabs.push(
      new DisplayTab("countdowntab", "Countdown Timer", 3, "", [CountdownView])
    );
    this.tabs.push(
      new DisplayTab("shadowrun", "ShadowRun Initiative Tracker", 4, "", [
        ShadowRunView,
      ])
    );
    this.tabs.push(
      new DisplayTab("cortexplus", "Cortex Plus Character Sheet", 5, "", [
        CortexView,
      ])
    );
  },
};
</script>
<style scoped>
</style>
